///<reference path="../../../components/pagerTemplates/employeeServicesCommissions/serviceCommissions.section.ts"/>


module Meevo.Plugins.Employee {
    "use strict";

    /**
    * Service Commissions Section of Employee
    */
    export class ServiceCommissionsSection extends Meevo.Components.BaseClasses.ServiceCommissionsSection {

    }
}